
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { WelcomeHero } from './components/WelcomeHero';
import { OnboardingSteps } from './components/OnboardingSteps';
import { CalendarSection } from './components/CalendarSection';
import { WelcomeFooter } from './components/WelcomeFooter';

export default function WelcomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFBFC]">
      {/* Minimal Nav */}
      <nav className="bg-white/80 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="text-primary font-extrabold text-xl tracking-tight font-nunito">
              Dino Nuggets
            </span>
          </Link>
          <div className="flex items-center gap-2 text-xs text-gray-400">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-double-line text-primary text-sm"></i>
            </div>
            <span className="text-primary font-medium">Order Confirmed</span>
          </div>
        </div>
      </nav>

      <WelcomeHero />
      <OnboardingSteps />
      <CalendarSection />
      <WelcomeFooter />
    </div>
  );
}
